const profileTypes = {
    ADMINISTRATOR: 1,
    FINANCIAL_ADVISOR: 2,
    STANDARD_USER: 3,
    CLIENT: 4,
};

export default profileTypes
